var _rect, _rect2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#4A4A4A",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-label": "News management icon: newspaper",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "News Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 2,
    ry: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 5,
    height: 4,
    rx: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 8,
    x2: 18,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 10,
    x2: 18,
    y2: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 18,
    y2: 14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 18,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsManagementIcon);
export default __webpack_public_path__ + "static/media/news-management-icon.4206008d1a5e13b357bad5c2e53a4f95.svg";
export { ForwardRef as ReactComponent };